import { blogPosts } from './blogPosts.js';
import { courseCatalog, firstFoodsFaqs } from './courseCatalog.js';

export const SITE_URL = 'https://www.lucilapistiner.com';
export const SITE_NAME = 'Lucila Pistiner';
export const DEFAULT_IMAGE = '/imagenpreviewenlace.webp';
export const SITE_LANGUAGE = 'es';
export const OG_LOCALE = 'es_AR';

const socialProfiles = [
  'https://www.instagram.com/lu.pistiner/',
  'https://www.linkedin.com/in/lucilapistiner/',
  'https://www.tiktok.com/@lu.pistiner',
  'https://www.youtube.com/@LuPistiner'
];

const siteDescription = 'Consultoría en sueño infantil, cursos online y acompañamiento para familias que buscan mejorar el descanso de sus bebés con información clara y respetuosa.';

const staticPageSeo = {
  '/': {
    title: 'Lucila Pistiner | Consultoría en sueño infantil',
    description: siteDescription,
    image: DEFAULT_IMAGE,
    keywords: ['sueño infantil', 'consultoría de sueño infantil', 'cursos de sueño infantil', 'bebés', 'crianza respetuosa'],
    schemaType: 'WebPage',
    breadcrumbLabel: 'Inicio'
  },
  '/nosotras': {
    title: 'Nosotras | Lucila Pistiner',
    description: 'Conocé a Lucila Pistiner y al equipo de profesionales que acompaña a familias en el sueño infantil, crianza y descanso de bebés.',
    image: '/FOTOS%20LUCILA%20WEB/LUCILA-NOSOTRAS-1.jpg',
    keywords: ['Lucila Pistiner', 'equipo sueño infantil', 'consultoras de sueño infantil'],
    breadcrumbLabel: 'Nosotras'
  },
  '/consultorias': {
    title: 'Consultorías personalizadas | Lucila Pistiner',
    description: 'Consultorías personalizadas de sueño infantil para acompañar a tu familia desde cualquier lugar del mundo.',
    image: 'https://lucilapistiner.com/wp-content/uploads/2025/05/plan-de-sueno-con-opcion-de-seguimiento.jpg',
    keywords: ['consultorías personalizadas', 'sueño del bebé', 'asesoría de sueño infantil'],
    breadcrumbLabel: 'Consultorías'
  },
  '/cursos': {
    title: 'Cursos online de sueño infantil | Lucila Pistiner',
    description: 'Cursos online de sueño infantil, destete nocturno, recién nacido y alimentación complementaria para acompañar cada etapa de tu bebé.',
    image: '/FOTOS%20LUCILA%20WEB/LUCILA-HERO-CURSOS.jpg',
    keywords: ['cursos online sueño infantil', 'curso sueño bebés', 'destete nocturno', 'primeros alimentos'],
    schemaType: 'CollectionPage',
    breadcrumbLabel: 'Cursos'
  },
  '/contacto': {
    title: 'Contacto | Lucila Pistiner',
    description: 'Contactá con Lucila Pistiner para consultas sobre cursos, consultorías personalizadas y acompañamiento en sueño infantil.',
    image: DEFAULT_IMAGE,
    keywords: ['contacto Lucila Pistiner', 'consultas sueño infantil'],
    breadcrumbLabel: 'Contacto'
  },
  '/blog': {
    title: 'Blog | Lucila Pistiner',
    description: 'Artículos y consejos sobre sueño infantil, crianza respetuosa, alimentación y desarrollo del bebé por Lucila Pistiner.',
    image: DEFAULT_IMAGE,
    keywords: ['blog sueño infantil', 'crianza respetuosa', 'bebés', 'maternidad'],
    schemaType: 'Blog',
    breadcrumbLabel: 'Blog'
  },
  '/podcast': {
    title: 'Sueño Sagrado | Lucila Pistiner',
    description: 'Sueño Sagrado, el podcast de Lucila Pistiner con conversaciones sobre sueño infantil, crianza real y maternidad.',
    image: '/podcast-living-room-hero.jpg',
    keywords: ['podcast sueño infantil', 'Sueño Sagrado', 'crianza real'],
    schemaType: 'PodcastSeries',
    breadcrumbLabel: 'Podcast'
  },
  '/privacidad': {
    title: 'Políticas de privacidad | Lucila Pistiner',
    description: 'Políticas de privacidad de Lucila Pistiner: uso de datos personales, formularios, cookies y derechos de los usuarios.',
    image: DEFAULT_IMAGE,
    noindex: true,
    excludeFromSitemap: true,
    breadcrumbLabel: 'Privacidad'
  },
  '/terminos-y-condiciones': {
    title: 'Términos y condiciones | Lucila Pistiner',
    description: 'Términos y condiciones de uso de cursos online, consultorías y servicios de Lucila Pistiner.',
    image: DEFAULT_IMAGE,
    noindex: true,
    excludeFromSitemap: true,
    breadcrumbLabel: 'Términos y condiciones'
  },
  '/terminos': {
    title: 'Términos y condiciones | Lucila Pistiner',
    description: 'Términos y condiciones de uso de cursos online, consultorías y servicios de Lucila Pistiner.',
    image: DEFAULT_IMAGE,
    canonicalPath: '/terminos-y-condiciones',
    noindex: true,
    excludeFromSitemap: true,
    breadcrumbLabel: 'Términos'
  },
  '/preguntas-frecuentes': {
    title: 'Preguntas frecuentes | Lucila Pistiner',
    description: 'Preguntas frecuentes sobre cursos online, consultorías personalizadas y acceso a materiales de Lucila Pistiner.',
    image: DEFAULT_IMAGE,
    keywords: ['preguntas frecuentes', 'cursos online', 'consultorías sueño infantil'],
    schemaType: 'FAQPage',
    breadcrumbLabel: 'Preguntas frecuentes'
  },
  '/combos': {
    title: courseCatalog.combos.seoTitle,
    description: courseCatalog.combos.description,
    image: courseCatalog.combos.image,
    canonicalPath: '/cursos/combos',
    noindex: true,
    excludeFromSitemap: true,
    breadcrumbLabel: 'Combos'
  }
};

const routeLabels = {
  '/': 'Inicio',
  '/nosotras': 'Nosotras',
  '/consultorias': 'Consultorías',
  '/cursos': 'Cursos',
  '/cursos/0-4-meses': '0 a 4 meses',
  '/cursos/4-20-meses': '4 a 20 meses',
  '/cursos/destete-nocturno': 'Destete nocturno',
  '/cursos/lo-que-necesitamos-saber': 'Cuando nace el bebé',
  '/cursos/primeros-alimentos': 'Primeros alimentos',
  '/cursos/combos': 'Combos',
  '/contacto': 'Contacto',
  '/blog': 'Blog',
  '/podcast': 'Podcast',
  '/preguntas-frecuentes': 'Preguntas frecuentes',
  '/privacidad': 'Privacidad',
  '/terminos-y-condiciones': 'Términos y condiciones'
};

const faqPageEntries = [
  {
    question: '¿Cuándo se recomienda tomar los cursos online?',
    answer: 'El curso para bebés de 0 a 4 meses se recomienda durante el último mes de embarazo, en las primeras semanas del bebé o antes de las 12 semanas. El curso para bebés de 4 a 20 meses se recomienda si tu bebé tiene entre 4 y 20 meses. El curso de primeros alimentos se recomienda entre los 5 y 15 meses inclusive.'
  },
  {
    question: '¿Los cursos online son compatibles si hago colecho?',
    answer: 'Sí. Los cursos son compatibles con colecho seguro.'
  },
  {
    question: '¿Puedo luego del curso online hacer una sesión personalizada?',
    answer: 'Sí. Podés realizar una sesión de refuerzo para concentrarnos en las dificultades de tu caso en particular.'
  },
  {
    question: '¿Cómo puedo acceder a los cursos online?',
    answer: 'Luego del pago tenés acceso inmediato durante 180 días corridos y podés verlo a tu propio ritmo desde celular, tablet o computadora con internet.'
  }
];

const coursePageSeo = Object.fromEntries(
  Object.values(courseCatalog).map((course) => [
    course.path,
    {
      title: course.seoTitle,
      description: course.description,
      image: course.image,
      keywords: [course.category, course.title, 'curso online', 'Lucila Pistiner'],
      breadcrumbLabel: course.title
    }
  ])
);

function absoluteUrl(path = '/') {
  if (/^https?:\/\//.test(path)) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

function normalizePathname(pathname = '/') {
  if (!pathname) return '/';
  if (pathname === '/') return '/';
  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
}

function getCourseFromPath(pathname) {
  const normalizedPath = normalizePathname(pathname);
  return Object.values(courseCatalog).find((course) => course.path === normalizedPath);
}

function buildOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': ['Organization', 'ProfessionalService'],
    name: SITE_NAME,
    url: SITE_URL,
    logo: absoluteUrl(DEFAULT_IMAGE),
    image: absoluteUrl(DEFAULT_IMAGE),
    description: siteDescription,
    email: 'info@lucilapistiner.com',
    sameAs: socialProfiles,
    areaServed: ['Argentina', 'Worldwide'],
    serviceType: ['Consultoría en sueño infantil', 'Cursos online de sueño infantil', 'Acompañamiento para familias']
  };
}

function buildWebsiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    inLanguage: SITE_LANGUAGE,
    description: siteDescription,
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL
    }
  };
}

function buildPersonSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Lucila Pistiner',
    url: SITE_URL,
    jobTitle: 'Consultora en sueño infantil',
    image: absoluteUrl(DEFAULT_IMAGE),
    sameAs: socialProfiles,
    worksFor: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL
    }
  };
}

function buildBreadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: absoluteUrl(item.path)
    }))
  };
}

function buildFaqSchema(entries) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: entries.map((entry) => ({
      '@type': 'Question',
      name: entry.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: entry.answer
      }
    }))
  };
}

function buildPodcastSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'PodcastSeries',
    name: 'Sueño Sagrado',
    url: absoluteUrl('/podcast'),
    description: staticPageSeo['/podcast'].description,
    inLanguage: SITE_LANGUAGE,
    image: absoluteUrl(staticPageSeo['/podcast'].image),
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL
    },
    sameAs: [
      'https://open.spotify.com/show/3HquQ8JUS2jD4agvfLLuCF',
      'https://www.youtube.com/@LuPistiner'
    ]
  };
}

function buildCourseSchema(course) {
  const offers = [];

  if (course.priceArs) {
    offers.push({
      '@type': 'Offer',
      url: course.buyHref,
      availability: 'https://schema.org/InStock',
      price: course.priceArs,
      priceCurrency: 'ARS'
    });
  }

  if (course.priceUsd) {
    offers.push({
      '@type': 'Offer',
      url: course.buyHref,
      availability: 'https://schema.org/InStock',
      price: course.priceUsd,
      priceCurrency: 'USD'
    });
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'Course',
    name: course.title,
    description: course.description,
    url: absoluteUrl(course.path),
    image: absoluteUrl(course.image),
    inLanguage: SITE_LANGUAGE,
    provider: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL
    },
    about: [course.category, 'bebés', 'crianza', 'familias'],
    audience: {
      '@type': 'Audience',
      audienceType: course.audience
    },
    offers: offers.length > 0 ? offers : undefined
  };
}

function buildPageSchema({ title, description, canonicalUrl, image, schemaType = 'WebPage' }) {
  return {
    '@context': 'https://schema.org',
    '@type': schemaType,
    name: title,
    description,
    url: canonicalUrl,
    image,
    inLanguage: SITE_LANGUAGE,
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL
    },
    about: ['sueño infantil', 'crianza', 'bebés', 'maternidad', 'paternidad']
  };
}

function buildBlogPostingSchema(post) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: post.title,
    description: post.excerpt,
    image: absoluteUrl(post.image),
    datePublished: post.date,
    dateModified: post.date,
    inLanguage: SITE_LANGUAGE,
    articleSection: 'Sueño infantil',
    author: {
      '@type': 'Person',
      name: 'Lucila Pistiner'
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: absoluteUrl(DEFAULT_IMAGE)
      }
    },
    mainEntityOfPage: absoluteUrl(`/blog/${post.slug}`)
  };
}

function getBreadcrumbItems(pathname, currentLabel) {
  const normalizedPath = normalizePathname(pathname);

  if (normalizedPath === '/') {
    return [{ name: 'Inicio', path: '/' }];
  }

  if (normalizedPath.startsWith('/blog/')) {
    return [
      { name: 'Inicio', path: '/' },
      { name: 'Blog', path: '/blog' },
      { name: currentLabel, path: normalizedPath }
    ];
  }

  if (normalizedPath.startsWith('/cursos/') && normalizedPath !== '/cursos/combos') {
    return [
      { name: 'Inicio', path: '/' },
      { name: 'Cursos', path: '/cursos' },
      { name: currentLabel, path: normalizedPath }
    ];
  }

  if (normalizedPath === '/cursos/combos' || normalizedPath === '/combos') {
    return [
      { name: 'Inicio', path: '/' },
      { name: 'Cursos', path: '/cursos' },
      { name: 'Combos', path: '/cursos/combos' }
    ];
  }

  return [
    { name: 'Inicio', path: '/' },
    { name: currentLabel ?? routeLabels[normalizedPath] ?? 'Página', path: normalizedPath }
  ];
}

function buildSchemasForStaticPage(pathname, seo) {
  const canonicalPath = seo.canonicalPath ?? pathname;
  const canonicalUrl = absoluteUrl(canonicalPath);
  const image = absoluteUrl(seo.image ?? DEFAULT_IMAGE);
  const breadcrumbItems = getBreadcrumbItems(pathname, seo.breadcrumbLabel);
  const schemas = [
    buildPageSchema({
      title: seo.title,
      description: seo.description,
      canonicalUrl,
      image,
      schemaType: seo.schemaType ?? 'WebPage'
    }),
    buildBreadcrumbSchema(breadcrumbItems)
  ];

  if (canonicalPath === '/podcast') {
    schemas.push(buildPodcastSchema());
  }

  if (canonicalPath === '/preguntas-frecuentes') {
    schemas.push(buildFaqSchema(faqPageEntries));
  }

  return schemas;
}

function buildSchemasForCourse(pathname, course, seo) {
  const canonicalPath = seo.canonicalPath ?? course.path;
  const breadcrumbItems = getBreadcrumbItems(canonicalPath, course.title);
  const schemas = [
    buildPageSchema({
      title: seo.title,
      description: seo.description,
      canonicalUrl: absoluteUrl(canonicalPath),
      image: absoluteUrl(course.image),
      schemaType: 'WebPage'
    }),
    buildBreadcrumbSchema(breadcrumbItems),
    buildCourseSchema(course)
  ];

  if (course.path === '/cursos/primeros-alimentos' && firstFoodsFaqs.length > 0) {
    schemas.push(buildFaqSchema(firstFoodsFaqs));
  }

  return schemas;
}

function buildSchemasForBlogPost(post) {
  const canonicalPath = `/blog/${post.slug}`;
  return [
    buildPageSchema({
      title: `${post.title} | Blog Lucila Pistiner`,
      description: post.excerpt,
      canonicalUrl: absoluteUrl(canonicalPath),
      image: absoluteUrl(post.image),
      schemaType: 'Article'
    }),
    buildBreadcrumbSchema(getBreadcrumbItems(canonicalPath, post.title)),
    buildBlogPostingSchema(post)
  ];
}

function getBlogSeo(pathname) {
  const slug = pathname.replace('/blog/', '').split('/')[0];
  const post = blogPosts.find((item) => item.slug === slug);
  if (!post) return null;

  return {
    title: `${post.title} | Blog Lucila Pistiner`,
    description: post.excerpt,
    image: post.image,
    type: 'article',
    publishedTime: post.date,
    modifiedTime: post.date,
    canonicalPath: `/blog/${post.slug}`,
    breadcrumbLabel: post.title,
    schemas: buildSchemasForBlogPost(post)
  };
}

function getCourseSeo(pathname) {
  const course = getCourseFromPath(pathname);
  if (!course) return null;

  const seo = {
    title: course.seoTitle,
    description: course.description,
    image: course.image,
    keywords: [course.category, course.title, 'curso online', 'Lucila Pistiner'],
    canonicalPath: course.path,
    breadcrumbLabel: course.title,
    schemas: []
  };

  seo.schemas = buildSchemasForCourse(pathname, course, seo);
  return seo;
}

export function getRouteSeo(pathname = '/') {
  const normalizedPath = normalizePathname(pathname);

  if (normalizedPath.startsWith('/blog/')) {
    return getBlogSeo(normalizedPath) ?? {
      ...staticPageSeo['/blog'],
      canonicalPath: normalizedPath,
      noindex: true,
      schemas: buildSchemasForStaticPage('/blog', staticPageSeo['/blog'])
    };
  }

  const courseSeo = getCourseSeo(normalizedPath);
  if (courseSeo) {
    return courseSeo;
  }

  const seo = staticPageSeo[normalizedPath] ?? staticPageSeo['/'];
  return {
    ...seo,
    schemas: buildSchemasForStaticPage(normalizedPath, seo)
  };
}

export function getSitemapRoutes() {
  return [
    ...Object.entries(staticPageSeo)
      .filter(([route, seo]) => !seo.excludeFromSitemap && (seo.canonicalPath == null || seo.canonicalPath === route))
      .map(([route]) => route),
    ...Object.keys(coursePageSeo)
  ];
}

export function getLlmsRoutes() {
  return [
    ...Object.entries(staticPageSeo)
      .filter(([, seo]) => !seo.excludeFromSitemap)
      .map(([route]) => route),
    ...Object.keys(coursePageSeo)
  ];
}

export function getPrerenderRoutes() {
  const routes = [
    ...Object.keys(staticPageSeo),
    ...Object.values(courseCatalog).map((course) => course.path),
    ...blogPosts.map((post) => `/blog/${post.slug}`)
  ];

  return [...new Set(routes)];
}

export const organizationSchema = buildOrganizationSchema();
export const siteSchemas = [buildOrganizationSchema(), buildWebsiteSchema(), buildPersonSchema()];
export const pageSeo = { ...staticPageSeo, ...coursePageSeo };
export { absoluteUrl };
